<app-collapsible-list>
  <app-collapsible-item>
    <app-collapsible-header [title]="explanationMotivesText.heading"></app-collapsible-header>
    <app-collapsible-body>
      <div [innerHTML]="explanationMotivesText.mainText" class="id37-text2 text-light"></div>
      <ul class="id37-text2 text-light">
        <li *ngFor="let bulletPoint of explanationMotivesText.bulletPointTexts" [innerHTML]="bulletPoint"></li>
      </ul>
      <div [innerHTML]="explanationMotivesText.endText" class="id37-text2 text-light"></div>
    </app-collapsible-body>
  </app-collapsible-item>
</app-collapsible-list>
